import { Byte, Encoder } from '@nuintun/qrcode';

export function getQRCodeGifDataUrl(text: string): string {
  const encoder = new Encoder({ level: 'H' });
  return encoder.encode(new Byte(text)).toDataURL();
}

// @nuintun/qrcode only encodes to gif, but react-pdf's <Image> only supports
// png/jpg/svg, so rasterize the gif through a canvas to get a png data URL.
export function getQRCodePngDataUrl(text: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const context = canvas.getContext('2d');
      if (!context) {
        reject(new Error('Unable to get 2D canvas context'));
        return;
      }
      context.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => reject(new Error('Failed to load QR code image'));
    img.src = getQRCodeGifDataUrl(text);
  });
}
